import { getQaCookies } from 'utils/get-qa-cookies';
import { Dispatch, RootState } from 'store';
import { createFeatureSelector } from 'common/create-feature-selector';
import { createSelector } from 'reselect';
import { charSets } from 'utils/constants';
import { getLangCookie } from 'utils/get-lang-cookie';
import { getEnv } from 'common/selectors';
import { GetBrandsConfig } from './api';
import { fetchBrandsThunk } from './brands-slice';
import { BrandsGroup } from '../types';

export const rootSelector = createFeatureSelector('allBrands');
export const getBrands = createSelector(rootSelector, (s) => s.data?.brands);
export const getStmBrands = createSelector(rootSelector, (s) => s.data?.stm);
export const getBrandsKeys = createSelector(rootSelector, (s) => Object.keys(s.data?.brands || {}));
export const getBrandsByRange = (group: BrandsGroup) =>
  createSelector(rootSelector, (s) => {
    if (group === 'all') return s.data?.brands;
    return Object.fromEntries(
      Object.entries(s.data?.brands || {}).filter(([key]) => charSets[group].indexOf(key) > -1),
    );
  });
export const getBrandsByChar = (char: string | null) =>
  createSelector(rootSelector, (s) =>
    Object.fromEntries(Object.entries(s.data?.brands || {}).filter(([key]) => key === char)),
  );

export const defineGroupByChar = (char: string) => {
  const comparableObject = {
    cyrillic: /[а-яА-ЯЁё]/.test(char),
    latin: /[a-zA-Z]/.test(char),
    numbers: /^[0-9]/.test(char),
  };
  return Object.entries(comparableObject)
    .map(([key, value]) => (value ? key : ''))
    .join('');
};

export const getActiveGroups = createSelector(rootSelector, (s) => {
  const literals = Object.keys(s.data?.brands || {}).join('');
  return {
    cyrillic: /[а-яА-ЯЁё]/.test(literals),
    latin: /[a-zA-Z]/.test(literals),
    numbers: /^[0-9]/.test(literals),
  };
});

export const fetchBrands = () => async (dispatch: Dispatch, getState: () => RootState) => {
  const state = getState();
  const qaCookie = getQaCookies(state.cookie);
  const lang = getLangCookie(state.cookie);
  const { ORCHESTRATOR_HOST, API_KEY, requestID } = getEnv(state);

  const options: GetBrandsConfig = {
    host: ORCHESTRATOR_HOST || '',
    config: { headers: { 'x-api-key': API_KEY, 'x-request-id': requestID } },
    params: {
      lang,
    },
  };

  if (qaCookie) {
    options.config = { ...options.config, headers: { cookie: qaCookie } };
  }

  return dispatch(fetchBrandsThunk(options));
};
